// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/page_mapping",
    element: lazy(() => import("../../pages/UserAccess/PageMapping/index")),
  },
  {
    path: "/page_mapping/add",
    element: lazy(() => import("../../pages/UserAccess/PageMapping/create")),
  },
  {
    path: "/page_mapping/edit/:id",
    element: lazy(() => import("../../pages/UserAccess/PageMapping/edit")),
  },
];

export default routes;
